module.exports = __webpack_public_path__ + "img/世航业绩未选中.7ac7d3e4.png";